import { useCallback } from 'react'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { Maybe, IUploadOutboundFilesInput, IUploadOutboundFilesReport } from 'types/graphqlTypes'
import { useStagingTestingUploadOutboundFilesMutation } from '../graphql/StagingTestingUploadOutboundFiles'

export const useUploadOutboundFiles = () => {
  const [uploadOutboundFilesMutation, { loading }] = useStagingTestingUploadOutboundFilesMutation()

  const { openToast } = useGlobalToast()

  const uploadOutboundFiles = useCallback(
    async (input: IUploadOutboundFilesInput): Promise<Maybe<IUploadOutboundFilesReport>> => {
      try {
        const response = await uploadOutboundFilesMutation({
          variables: {
            input,
          },
        })

        const { data } = response || {}
        const { stagingTestingUploadOutboundFiles } = data || {}
        const { errors = [], uploadOutboundFilesReport } = stagingTestingUploadOutboundFiles || {}

        const filteredErrors = errors.filter(item => !!item.message).map(i => i.message)

        const { errorMessage, success } = uploadOutboundFilesReport || {}

        if (!success) {
          openToast({
            toastMessage: `${filteredErrors.join(', ')} ${errorMessage}` || 'Unknown error occured',
            toastType: 'alert',
          })
        } else {
          openToast({
            toastMessage: 'Outbound Files Uploaded Successfully.',
            toastType: 'default',
          })
        }
        return uploadOutboundFilesReport
      } catch (e) {
        openToast({ toastMessage: e.message, toastType: 'alert' })
        return undefined
      }
    },
    [uploadOutboundFilesMutation, openToast]
  )

  return { uploadOutboundFiles, loading }
}
